(() => {
  angular
    .module('gm.common.websockets', [])
    .factory('BtgEventEmitter', BtgEventEmitterFactory)
    .factory('BtgSocket', BtgSocketFactory)
    .factory('gmSocketFactory', gmSocketFactoryFactory);

  function BtgEventEmitterFactory() {
    'ngInject';

    // Base class for handling events.
    function BtgEventEmitter() {
      this._events = {};
    }

    BtgEventEmitter.prototype = {
      // Adds a callback to an event.
      on(event, callback) {
        if (!angular.isArray(this._events[event])) {
          this._events[event] = [];
        }

        if (angular.isFunction(callback)) {
          this._events[event].push(callback);
        }
      },

      // Removes a callback from an event.
      off(event, callback) {
        if (angular.isArray(this._events[event]) && angular.isFunction(callback)) {
          this._events[event] = this._events[event].filter(item => item !== callback);
        }
      },

      // Adds a callback to be executed only once.
      once(event, callback) {
        const once = function _once(...args) {
          callback.apply(this, args);
          this.off(event, once);
        };
        this.on(event, once);
      },

      // Emits an event calling all callbacks with passed arguments.
      emit(event, args) {
        if (angular.isArray(this._events[event])) {
          const callargs = args || [];
          const callbacks = this._events[event];
          let length = callbacks.length;
          let index = 0;

          while (index < length) {
            callbacks[index].apply(this, callargs);

            if (callbacks.length === length) {
              index += 1;
            } else {
              length = callbacks.length;
            }
          }
        }
      }
    };

    return BtgEventEmitter;
  }

  function BtgSocketFactory(
    $window,
    BtgEventEmitter,
    Environment
  ) {
    'ngInject';

    const DEBUG_WEBSOCKET = Environment.settings.websocket && Environment.settings.websocket.debug;

    const ReconnectingWebSocket = $window.ReconnectingWebSocket;
    let _socket = null;
    let _url;

    // Base class for handling WebSockets.
    function BtgSocket(url) {
      _url = url;
      BtgEventEmitter.call(this);
    }

    BtgSocket.prototype = angular.extend({}, BtgEventEmitter.prototype, {
      // Connects to WebSocket url.
      connect() {
        if (ReconnectingWebSocket) {
          _socket = new ReconnectingWebSocket(_url, null, {
            automaticOpen: true,
            debug: DEBUG_WEBSOCKET,
            ignoreProxyConnectionErrors: false,
            timeoutInterval: 10000,
            maxReconnectAttempts: 7,
          });

          _socket.onopen = function _onopen(event) {
            this.emit('connect', [event]);
          }.bind(this);

          _socket.onclose = function _onclose(event) {
            this.emit('disconnect', [event]);
          }.bind(this);

          _socket.onerror = function _onerror(event) {
            this.emit('error', [event.data]);
          }.bind(this);

          _socket.onmessage = function _onmessage(event) {
            let error;
            let message;

            try {
              message = JSON.parse(event.detail.data);
            } catch (e) {
              error = e;
            }

            if (error) {
              this.emit('error', [error]);
            } else {
              this.emit('message', [message]);
            }
          }.bind(this);
        }
      },

      // Closes the websocket connection.
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      disconnect() {
        if (ReconnectingWebSocket) {
          try {
            _socket.close();
          } catch (e) {}
        }
      },

      close() {
        if (ReconnectingWebSocket) {
          this.disconnect();
        }
      },

      // Sends a json message to the other peer.
      send(message) {
        if (ReconnectingWebSocket) {
          if (_socket.readyState === 1) {
            _socket.send(JSON.stringify(message));
          }
        }
      }
    });

    return BtgSocket;
  }

  function gmSocketFactoryFactory(
    BtgSocket,
    Environment
  ) {
    'ngInject';

    const WS_HOST = Environment.websocket;

    return {
      create,
    };

    function create(url) {
      return new BtgSocket(WS_HOST + url);
    }
  }
})();
